module.exports = __webpack_public_path__ + "static/madeline-ab410813dedfe60d1447f4f5cfd62d14.jpg";